import React from 'react';
import * as S from './Divider.styled';
export const Divider = ({ label, marginTop, marginBottom, }) => {
    return (React.createElement(S.Container, { "$marginTop": marginTop, "$marginBottom": marginBottom },
        React.createElement(S.Divider, null),
        label && React.createElement(S.Label, null, label),
        React.createElement(S.Divider, null)));
};
